// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import pxToEm from 'theme/pxToEm';
import { ArrowDirection } from './HorizontalScroll';

type DirectionProps = { direction: ArrowDirection; show?: boolean };

export const Wrapper = styled.div<{ withMobilePadding?: boolean }>`
  position: relative;
  width: 100%;
  overflow-x: auto;
  ${({ theme }) => theme.breakpoints.down('md')} {
    ${({ withMobilePadding }) =>
      withMobilePadding &&
      `
      padding: 0px 16px;
      display: flex;
      flex-wrap: nowrap;
    `}
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Arrow = styled.div<DirectionProps>`
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  opacity: ${({ show }) => (show ? 1 : 0)};
  height: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  right: ${({ direction }) =>
    direction === ArrowDirection.RIGHT ? 0 : 'auto'};
  left: ${({ direction }) => (direction === ArrowDirection.LEFT ? 0 : 'auto')};
  top: 0;
  z-index: 2;
  transition: all 0.1s linear;
  pointer-events: none;
  & button {
    width: 36px;
    height: 36px;
    font-size: 0.9em;
    background: ${({ theme }) => theme.palette.secondary?.main} !important;
    color: ${({ theme }) => theme.palette.primary.main} !important;
    pointer-events: auto;
    &:focus,
    &:active {
      color: ${({ theme }) => theme.palette.primary.main} !important;
      background: ${({ theme }) => theme.palette.secondary?.main} !important;
    }
  }
`;

export const Shadow = styled.div<DirectionProps>`
  height: 100%;
  width: ${pxToEm(48)};
  pointer-events: none;
  background: ${({ direction }) =>
    `linear-gradient(${
      direction === ArrowDirection.RIGHT ? '270deg' : '90deg'
    }, #ffffff 0%, rgba(255, 255, 255, 0) 100%)`};
`;
